export default __webpack_public_path__ + "1556c389d696d829c1ad5b5339a24dca.svg";